import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import {
  fetchAcademicSessions,
  selectAllSessions,
  selectSessionsLoading,
  selectSessionsError,
} from "../../../../Slices/sessionsSlice";
import AddBookFee from "./AddBookFee";
import BooksFeeList from "./BooksFeeList";
import { getBooksFeeDetails } from "../../../../ApiService/ApiService";
import { Add, ArrowBack } from "@mui/icons-material";

function BookFeeHistory({
  setActionComponent,
  selectedStudentId,
  studentName,
  classes,
  selectedClassId,
}) {
  const dispatch = useDispatch();
  const sessions = useSelector(selectAllSessions);
  const sessionsLoading = useSelector(selectSessionsLoading);
  const sessionsError = useSelector(selectSessionsError);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [showAddBookFee, setShowAddBookFee] = useState(false);
  const [bookFeeHistory, setBookFeeHistory] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessions?.data?.length > 0) {
      setSelectedSessionId(sessions.data[0].id);
    }
  }, [sessions]);

  useEffect(() => {
    dispatch(fetchAcademicSessions());
  }, [dispatch]);

  const handleSessionChange = (event) => {
    const sessionId = event.target.value;
    setSelectedSessionId(sessionId);
  };

  const fetchBookFeeDetails = async (selectedStudentId, selectedSessionId) => {
    try {
      setLoading(true);
      if (selectedStudentId && selectedSessionId) {
        const response = await getBooksFeeDetails(
          selectedStudentId,
          selectedSessionId
        );
        // console.log("RES", response?.data);
        setBookFeeHistory(response?.data);
      }
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookFeeDetails(selectedStudentId, selectedSessionId);
  }, [selectedSessionId]);

  // console.log(bookFeeHistory);

  const renderMainContent = () => {
    if (showAddBookFee) {
      return (
        <AddBookFee
          setShowAddBookFee={setShowAddBookFee}
          fetchBookFeeDetails={fetchBookFeeDetails}
          selectedStudentId={selectedStudentId}
          studentName={studentName}
          classes={classes}
          selectedClassId={selectedClassId}
        />
      );
    } else {
      return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl size="small" sx={{ marginTop: 2, marginBottom: 2 }}>
            <InputLabel id="session">Session</InputLabel>
            <Select
              name="sessionId"
              label="Session"
              labelId="session"
              value={selectedSessionId}
              onChange={handleSessionChange}
              size="small"
              disabled={sessionsLoading || sessionsError}
              sx={{ width: "25%" }}
            >
              {sessions?.data?.length > 0 ? (
                sessions?.data?.map((currSession) => (
                  <MenuItem key={currSession?.id} value={currSession?.id}>
                    {currSession?.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Sessions unavailable</MenuItem>
              )}
            </Select>
          </FormControl>
          <BooksFeeList bookFeeHistory={bookFeeHistory} />
        </Box>
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddBookFee ? "none" : "flex",
          // justifyContent: "space-around",
        }}
      >
        <Typography
          paragraph
          sx={{
            color: "black",
            fontWeight: 600,
            fontSize: 22,
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Books Fee History
        </Typography>
        <Box xs={8} sm={8} md={6} lg={4} xl={4} sx={{ marginLeft: "auto" }}>
          {" "}
          <Button
            variant="contained"
            color="inherit"
            size="small"
            sx={{
              marginBottom: 2,
              textTransform: "unset",
              borderRadius: 2,
              marginRight: 1,
            }}
            onClick={() => setActionComponent(null)}
          >
            <ArrowBack fontSize="small" sx={{ marginRight: 1 }} />
            Back
          </Button>
        </Box>
        <Button
          onClick={() => setShowAddBookFee(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Book Fee
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default BookFeeHistory;
